import React, { useState } from "react";
import "../assets/css/Login.css";
import { FaEnvelope, FaLock } from "react-icons/fa";
import LoginPc from "../assets/images/computer.png";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import CircularProgress from "@mui/material/CircularProgress";
import { useTranslation } from "react-i18next";

const loginSchema = yup.object().shape({
  Username: yup.string().required("User Name Is Required"),
  Password: yup.string().required("Password Is Required"),
});

const Login = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(loginSchema),
  });

  const onSubmit = async (data) => {
    setLoading(true);
    setErrorMessage("");

    try {
      const response = await axios.post(
        "https://vsoftrunners.com-eg.net/api/RunnerUsers/V7/Login",
        data,
        {
          headers: {
            CompanyID: "212606",
          },
        }
      );

      console.log(response.data); // تحقق من محتوى الرد هنا

      // تحقق من وجود accessToken و isActive
      if (response.data.isActive && response.data.accessToken) {
        // حفظ بيانات المستخدم في localStorage
        localStorage.setItem("userData", JSON.stringify(response.data));
        console.log("توجيه إلى الصفحة الرئيسية...");
        navigate("/home-page");
      } else {
        setErrorMessage("بيانات الدخول غير صحيحة");
      }
    } catch (error) {
      // إذا كان الرد يحتوي على حالة 401 Unauthorized
      if (error.response && error.response.status === 401) {
        // مسح بيانات المستخدم والخروج
        localStorage.removeItem("userData");
        navigate("/"); // التوجيه إلى الصفحة الرئيسية
      } else {
        setErrorMessage("حدث خطأ أثناء محاولة تسجيل الدخول");
      }
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            width: "100%",
            position: "fixed",
            top: 0,
            left: 0,
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            zIndex: 1000,
          }}
        >
          <CircularProgress size={80} />
        </div>
      ) : (
        <div className="login-container">
          <div className="login-card">
            <div className="login-image">
              <img src={LoginPc} alt="Login Illustration" />
            </div>
            <div className="login-form">
              <h2>{t("login")}</h2>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="input-group">
                  <FaEnvelope className="input-icon" />
                  <input
                    type="text"
                    placeholder={t("username")}
                    {...register("Username")}
                  />
                  {errors.Username && (
                    <p className="error-message">{errors.Username.message}</p>
                  )}
                </div>
                <div className="input-group">
                  <FaLock className="input-icon" />
                  <input
                    type="password"
                    placeholder={t("password")}
                    {...register("Password")}
                  />
                  {errors.Password && (
                    <p className="error-message">{errors.Password.message}</p>
                  )}
                </div>

                {errorMessage && (
                  <div className="error-message">{errorMessage}</div>
                )}
                <div className="input-group">
                  <button
                    type="submit"
                    className="login-button"
                    disabled={loading}
                  >
                    {t("login")}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Login;
